/* eslint-disable no-eval */
import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withSnackbar } from "notistack";
import { withRouter } from "../../../shared/hoc/withRouter";
import * as contractsCrud from "../../../crud/contracts.crud";
import store from "../../../store/store";           
import { allMessages } from "../../../../_metronic/i18n/I18nProvider";
import { alert } from 'devextreme/ui/dialog';
import { typographyClasses } from "@mui/material";

const PARTY_TO_RESOURCE_KEY = {
  PM: "PM_NAME",
  Contractor: "SUPPLIER_NAME",
  Supervisor: "SUPERVISOR_NAME",
  Client: "CLIENT_NAME"
};

class RequestContractEmailAddress extends React.Component {
  onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { contractId, contractUser, contractTemplate } = this.props;

    const party = contractUser?.party;
    const partyName = contractTemplate?.resources?.[PARTY_TO_RESOURCE_KEY[party]] || "";
    const description = this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.DESCRIPTION" }, { PARTY_NAME: partyName });
    
    const storeState = store.getState();
    const lang = storeState.i18n.lang;

    const title = this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.TITLE" });

    let emailAddress = "";
    let errorText = "";

    try {
      const response = await contractsCrud.getContractEmailAddress(contractId);
      const data = response.data || {};

      emailAddress = data.EmailAddress || data.emailAddress || "";

      if (!emailAddress) {
        errorText = this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.NO_EMAIL" });
      }
    } catch (err) {
      errorText =
        err?.response?.data?.description ||
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message || this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.EMAIL_ERROR" });
    }

    if (errorText) {
      await alert(
        `<div style="max-width:50vw;min-width:300px;white-space:pre-wrap;">${String(errorText)}</div>`,
        title
      );
      return;
    }

    const warningBlock = `
      <div style="
        margin-bottom:12px;
        padding:10px;
        background:#FFF4E5;
        border:1px solid #FFD8A8;
        border-left:4px solid #F59F00;
        border-radius:4px;
        color:#5f3b00;
      ">
        ${this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.WARNING" })}
      </div>
    `;

    const message =
      `<div style="max-width:50vw;min-width:300px;max-width:550px;">` +
        warningBlock +
        `<div style="margin-bottom:8px;">${description}</div>` +

        `<div style="display:flex;align-items:center;gap:8px;">` +
          `<input id="fd-email-copy" type="text" readonly value="${emailAddress}" ` +
            `style="flex:1;padding:10px;border:1px solid #ddd;border-radius:4px;" />` +

          `<button id="fd-copy-btn" title="Copy to clipboard" ` +
            `style="padding:6px 10px;border:1px solid #3F96C4;background:#fff;color:#3F96C4;border-radius:4px;cursor:pointer;min-width:50px;" ` +
            `onclick="(function(btn){` +
              `var el=document.getElementById('fd-email-copy');` +
              `if(el){ el.select(); document.execCommand('copy'); }` +

              `btn.innerText='Copied';` +
              `btn.style.color='#2f9e44';` +
              `btn.style.borderColor='#2f9e44';` +

              `setTimeout(function(){` +
                `btn.innerText='Copy';` +
                `btn.style.color='#3F96C4';` +
                `btn.style.borderColor='#3F96C4';` +
              `}, 1500);` +
            `})(this)">Copy</button>` +
        `</div>` +
      `</div>`;

    await alert(message, this.props.intl.formatMessage({ id: "EMAILDRAFTER.POPUP.TITLE" }));
  };

  render() {
    if (process.env.REACT_APP_EMAIL_DRAFTER_ENABLED !== "true") return null;

    const tooltip = this.props.intl.formatMessage({ id: "EMAILDRAFTER.LINK" });

    // Icon needs to be subtle so it doesn't distract from main UI as we are trying to 
    // not promote this feature too heavily :)
    return (
      <a
        href="#"
        onClick={this.onClick}
        title={tooltip}
        aria-label={tooltip}
        style={{
          color: "#3F96C4",
          opacity: 0.95,
          fontSize: "1.5rem",
          textDecoration: "none",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          transition: "opacity 0.15s ease, color 0.15s ease",
          marginLeft: "5px"
        }}
      >
        <i className="fas fa-paper-plane" />
      </a>
    );
  }
}

export default withRouter(withSnackbar(injectIntl(connect()(RequestContractEmailAddress))));